{
  "name": "hb-frontend",
  "version": "7.0.0",
  "license": "MIT",
  "angular-cli": {},
  "scripts": {
    "start": "ng serve",
    "start-dev": "ng serve --configuration=localwithazuredevbackend",
    "start-local": "ng serve --configuration=localwithlocalrestbackend",
    "prestart-dev": "node generate.js",
    "lint": "tsc --noEmit && eslint . --ext js,ts,json --quiet",
    "build": "ng build",
    "prebuild": "node generate.js",
    "build:jenkins-ci": "ng build --configuration=jenkins-ci",
    "prebuild:jenkins-ci": "node generate.js",
    "build:prod": "ng build --configuration=production",
    "prebuild:prod": "node generate.js",
    "build:testing": "ng build --configuration=testing",
    "prebuild:testing": "node generate.js",
    "prestart": "node generate.js",
    "prestart-local": "node generate.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.1",
    "@angular/cdk": "22.2.2",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/fire": "20.1.0",
    "@angular/forms": "22.2.1",
    "@angular/material": "22.2.2",
    "@angular/material-moment-adapter": "22.2.2",
    "@angular/platform-browser": "22.2.1",
    "@angular/platform-browser-dynamic": "22.2.1",
    "@angular/platform-server": "22.2.1",
    "@angular/router": "22.2.1",
    "@angular/service-worker": "22.2.1",
    "@ngbracket/ngx-layout": "22.0.1",
    "@swimlane/ngx-datatable": "25.1.0",
    "@types/d3-scale-chromatic": "3.0.0",
    "angularx-qrcode": "14.0.0",
    "buffer": "^6.0.3",
    "d3": "7.0.1",
    "d3-scale-chromatic": "3.0.0",
    "date-time-format-timezone": "1.0.22",
    "file-saver": "2.0.5",
    "firebase": "11.10.0",
    "hammerjs": "2.0.8",
    "hex-to-rgba": "^2.0.1",
    "jspdf": "2.3.1",
    "jspdf-autotable": "3.5.20",
    "luxon": "^3.7.2",
    "moment": "2.29.1",
    "moment-timezone": "0.5.33",
    "mqtt": "^4.3.7",
    "ng2-file-upload": "3.0.0",
    "ngx-material-timepicker": "^13.1.1",
    "print-js": "1.6.0",
    "process": "^0.11.10",
    "rxjs": "7.8.2",
    "stacktrace-js": "2.0.2",
    "tslib": "2.3.1",
    "urijs": "1.19.7",
    "url": "^0.11.4",
    "worker-timers": "^8.0.0",
    "xlsx": "0.17.1",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.2",
    "@angular/cli": "22.2.2",
    "@angular/compiler-cli": "22.2.1",
    "@angular/pwa": "12.2.5",
    "@types/d3": "7.0.0",
    "@types/hammerjs": "2.0.40",
    "@types/luxon": "^3.7.5",
    "@types/moment-timezone": "0.5.30",
    "@types/node": "16.9.0",
    "@types/paho-mqtt": "1.0.5",
    "@typescript-eslint/eslint-plugin": "4.31.0",
    "eslint": "7.32.0",
    "eslint-config-prettier": "8.3.0",
    "eslint-plugin-prettier": "4.0.0",
    "prettier": "2.3.2",
    "prettier-eslint": "13.0.0",
    "sass": "1.39.0",
    "ts-node": "10.2.1",
    "typescript": "6.0.3"
  },
  "engines": {
    "node": "^22.22.3",
    "npm": "^10.9.0"
  },
  "overrides": {
    "fsevents": "^2.3.2"
  }
}
